import { h } from 'preact';
import createDataTable, { tableUtils } from '../cloudquote-data-table';
import { formatNumber, intlDateNode, generatePriceFormatter } from '../../lib/util';
import { getStockPriceHistory } from '@os/cloudquote';
import { Text } from 'preact-i18n';

const INTL_NS = 'historical-data-panel.headers';

const FOOTNOTES = ['adjustedClose'].map((name) => (
	{ name, text: <Text id={name} /> }
));

let HistoricalData = ({ symbolTypeCode, ...props }) => {
	let formatter = generatePriceFormatter({ SecurityTypeCode: symbolTypeCode }, { Default: '-' });
	let HistoricalDataTable = createDataTable({
		headers: [
			<Text id={`${INTL_NS}.date`} />,
			<Text id={`${INTL_NS}.open`} />,
			<Text id={`${INTL_NS}.high`} />,
			<Text id={`${INTL_NS}.low`} />,
			<Text id={`${INTL_NS}.close`} />,
			{
				name: <Text id={`${INTL_NS}.adjustedClose`} />,
				footnotes: FOOTNOTES,
				id: 'adjustedClose'
			},
			<Text id={`${INTL_NS}.volume`} />
		],
		cells: [
			tableUtils.formatField('Date', intlDateNode),
			priceFormatField('Open', formatter),
			priceFormatField('High', formatter),
			priceFormatField('Low', formatter),
			priceFormatField('Close', formatter),
			priceFormatField('Adjusted Close', formatter),
			tableUtils.formatField('Volume', (value) => formatNumber(value,
				{ Comma: true }
			))
		],
		sort: tableUtils.sort.descending.dateByKey('Date'),
		maxRows: 25,
		apiMethod: ({ symbol }) => getStockPriceHistory(symbol),
		footnotes: FOOTNOTES
	});

	return (
		<HistoricalDataTable {...props} />
	);
};

function priceFormatField(field, formatter) {
	return tableUtils.formatField(field, (value) => formatter(value));
}

export default HistoricalData;
